import PropTypes from "prop-types";

import DrawerHeaderStyled from "./DrawerHeaderStyled";
import LogoSection from "../../../logo/LogoSection";

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: "60px",
        width: "initial",
        paddingTop: "8px",
        paddingBottom: "8px",
        paddingLeft: open ? "24px" : 0,
      }}
    >
      <LogoSection
        isIcon={!open}
        sx={{ width: open ? "auto" : 35, height: 35 }}
      />
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
